import deepGroupBy from "@/services/groupByUtil.js";
import BaseModelVestingSchedule from "@/models/BaseModelVestingSchedule.js";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelTransactionLog from "@/models/BaseModelTransactionLog.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelAllocation from "@/models/BaseModelAllocation.js";
import BaseInvestmentValuation from "@/models/BaseModelInvestmentValuation.js";

import moment from "moment";
import { isNullOrUndefined } from "util";

export default {
    name: "PartnerInvestorMixin",
    data: function () {
        return {
        BaseModelProgram: BaseModelProgram,
        BaseModelAllocation: BaseModelAllocation,
        BaseModelTransactionLog: BaseModelTransactionLog,
        BaseInvestmentValuation: BaseInvestmentValuation,
        BaseModelUnitClass: BaseModelUnitClass,
        BaseModelVestingSchedule: BaseModelVestingSchedule,
        classRunningTotalDict: {},
        ProgramInfo: {},
        classRunningBonusUnits : {},
        bonusUnits : "",
        ExceptionProgram : {
          "Master" : {"Id" : 81,"ProgramID" : 30010, "InvestmentId" : 49,"InvestmentInvestmentId" : 500010},
          "Child" : {"Id" : 82,"ProgramID" : 30011, "InvestmentId" : 50,"InvestmentInvestmentId" : 500011}
        },        
        };
    },
    methods: {
        getPartnerDistribution: function (partnerId, programId, taxDate) {
            const self = this;
            self.isNonPartner = false;
            let distributionAPIData = self.withFilter(
                self.BaseModelDistribution.list
            );

            let filteredDistribution = _.filter(distributionAPIData, function (obj) {
                return (
                    obj.PartnerId == partnerId &&
                    obj.ProgramId == programId &&
                    new Date(obj.DistributionDate) < new Date(taxDate)
                );
            });

            if (filteredDistribution.length) {
                var groupedDistribution = window.linq.from(filteredDistribution)
                    .groupBy("$.PartnerId", null, function (key, obj) {
                        return {
                            PartnerId: key,
                            Result: window.linq.from(obj)
                                .groupBy(
                                    "$.ProgramId",
                                    null,
                                    "{ PartnerId: $$.min('($.PartnerId)'),ProgramId: $, DistributionAmount: $$.sum('Number($.DistributionAmount)')}"
                                )
                                .toArray()
                        };
                    })
                    .toArray();
            }

            var returnInvestorDistribution = 0;
            if (groupedDistribution) {
                if (groupedDistribution[0].Result.length) {
                    returnInvestorDistribution = groupedDistribution[0].Result[0].DistributionAmount;
                }
            }
            else {
                returnInvestorDistribution = 0;
            }
            return returnInvestorDistribution;
        },

        getInvestorValuation: function (partnerId, investmentId, taxDate) {
            const self = this;
            var taxYearQuarter = this.getTaxYearQuarter(taxDate);

            let filterQuery = {
              filter : "InvestmentId eq" + investmentId +" and TaxYearQuarter eq" + taxYearQuarter
            };

            let valuationData = self.withFilter(self.BaseInvestmentValuation,filterQuery);

            let valuationAPIData = self.withFilter(
                self.BaseModelAllocation.list
            );

            let filteredValuation = _.filter(valuationAPIData, function (obj) {
                return (
                    obj.PartnerId == partnerId &&
                    obj.InvestmentId == investmentId &&
                    obj.TaxYearQuarter == taxYearQuarter
                );
            });

            var returnInvestorValuation = {
                ProjectedValue: 0,
                CurrentValue: 0
            };

            if (filteredValuation.length) {
                for (var i = 0; i < filteredValuation.length; i++) {
                    returnInvestorValuation.ProjectedValue = returnInvestorValuation.ProjectedValue + filteredValuation[0].ProjectedValue;
                    returnInvestorValuation.CurrentValue = returnInvestorValuation.CurrentValue + filteredValuation[0].CurrentValue;
                }
            }
            return returnInvestorValuation;
        },

        getTaxYearQuarter: function (taxDate) {
            var d = new Date(taxDate);
            var q = Math.ceil(d.getMonth() / 3);
            return d.getFullYear() + " Q" + q;
        },

        getUnitCalculationByProgram(programId, partnerId, unitClass, vestingType) {
            this.classRunningTotalDict = {};
            this.classRunningBonusUnits = {};
            this.bonusUnits = 0;      
            if (this.selectedDate == null) {
              this.selectedDate = new Date();
            }
      
            if (programId) {
              var self = this;
              let storeResponse = this.getJoinedItemsFilter({
                parentConfig: BaseModelProgram,
                parentId: programId,
                keyToJoin: "Program/Id",
                childConfigs: [
                  BaseModelTransactionLog,
                  BaseModelUnitClass,
                  BaseModelVestingSchedule
                ]
              });
              let response = JSON.parse(JSON.stringify(storeResponse));
              this.ProgramInfo = response;
      
              //var tranData = _.concat(response.children.Transfer,response.children.Forfeiture,response.children.Issuance);
              let tranData = _.filter(response.children.TransactionLog, function(o) {
                return moment(o.TransactionDate) <= moment(self.selectedDate);
              });
              //Add Exception Program, Two programs data into one
              let mergeTranData;
              if(programId == self.ExceptionProgram.Master.Id || programId == self.ExceptionProgram.Child.Id)
              {
                let master;
                let child;
                if(programId == self.ExceptionProgram.Master.Id) {
                   master = self.ExceptionProgram.Master.Id;
                   child = self.ExceptionProgram.Child.Id;
                } else {
                  master = self.ExceptionProgram.Child.Id;
                  child = self.ExceptionProgram.Master.Id;
                }
                let filterQuery = {
                  filter: "ProgramId eq " + child
                };
      
                let resultMergeProgram = self.withFilter(
                  self.BaseModelTransactionLog.list,
                  filterQuery
                );
      
                if(resultMergeProgram.length) {
                  mergeTranData = _.filter(resultMergeProgram, function(o) { return moment(o.TransactionDate) <= moment(self.selectedDate); 
                  });
                  mergeTranData.forEach(function(item){
                    item.ProgramId = master;
                    tranData.push(item);
                  });
                }
                console.log("Transaction Data",tranData);
      
              }
              //Bonus units deduction on the fly              
              //self.calcBonusUnits(tranData);

              //deepGroupByTest
      
              const getConfig1 = item => item.PartnerId;
              const getConfig2 = item => item.UnitClass;
              const getConfig3 = item => item.VestingType;
              const getConfig4 = item => item.UnitType;
              const getConfig5 = item => item.BusinessEvent;
      
              var groupByResult = deepGroupBy(
                tranData,
                getConfig1,
                getConfig2,
                getConfig3,
                getConfig4,
                getConfig5
              );
              console.log(groupByResult);
              var calculatedPartnerInfo = [];
              var taxRunningTotal = 0;
              var FMVRunningTotal = 0;
      
              //Calculate transaction details for each partner from transaction records
      
              Object.keys(groupByResult).forEach(function(partnerkey, partnerindex) {
                //console.log(result[key])
                // key: the name of the object key
                // index: the ordinal position of the key within the object
                let partnerResult = groupByResult[partnerkey];
                Object.keys(partnerResult).forEach(function(
                  unitclasskey,
                  unitclassindex
                ) {
                  let result = partnerResult[unitclasskey];
                  Object.keys(result).forEach(function(key, index) {
                    var partner = {};
                    partner.Id = partnerkey;
                    partner.PartnerID = null;
                    partner.PartnerTaxStatus = "";
                    partner.UnitClass = unitclasskey;
                    partner.VestingType = key;
                    partner.Ownership = 0;
                    partner.PartnerType = "";
                    partner.StandardIssuance = 0;
                    partner.StandardTransfer = 0;
                    partner.StandardForfeiture = 0;
                    partner.StandardTotal = 0;
                    partner.SupplementalIssuance = 0;
                    partner.SupplementalTransfer = 0;
                    partner.SupplementalForfeiture = 0;
                    partner.SupplementalTotal = 0;
                    partner.TotalUnits = 0;
                    partner.AdjustedTotalUnits = 0;
                    partner.TaxOwnership = 0;
                    partner.FMVOwnership = 0;
      
                    // var IssuanceData=result[key].Standard.Issuance
      
                    //read Inside Standard and Supplemental
                    var partnerBusinessEventData = result[key];
      
                    //console.log(partnerBusinessEventData.Standard.Issuance)
                    //Standard Calculation
                    if (
                      partnerBusinessEventData &&
                      partnerBusinessEventData.Standard
                    ) {
                      if (partnerBusinessEventData.Standard.Issuance) {
                        let IssuanceArray =
                          partnerBusinessEventData.Standard.Issuance;
                        self.calcSum(
                          IssuanceArray,
                          "Unit",
                          partner,
                          "StandardIssuance"
                        );
                      }
                      if (partnerBusinessEventData.Standard.Transfer) {
                        let TransferArray =
                          partnerBusinessEventData.Standard.Transfer;
                        self.calcSum(
                          TransferArray,
                          "Unit",
                          partner,
                          "StandardTransfer"
                        );
                      }
                      if (partnerBusinessEventData.Standard.Forfeiture) {
                        let ForfeitureArray =
                          partnerBusinessEventData.Standard.Forfeiture;
                        self.calcSum(
                          ForfeitureArray,
                          "Unit",
                          partner,
                          "StandardForfeiture"
                        );
                      }
      
                      partner.StandardTotal =
                        partner.StandardIssuance +
                        partner.StandardTransfer +
                        partner.StandardForfeiture;
                    }
                    //Supplemental Calculation
                    if (
                      partnerBusinessEventData &&
                      partnerBusinessEventData.Supplemental
                    ) {
                      if (partnerBusinessEventData.Supplemental.Issuance) {
                        let IssuanceArray =
                          partnerBusinessEventData.Supplemental.Issuance;
                        self.calcSum(
                          IssuanceArray,
                          "Unit",
                          partner,
                          "SupplementalIssuance"
                        );
                      }
                      if (partnerBusinessEventData.Supplemental.Transfer) {
                        let TransferArray =
                          partnerBusinessEventData.Supplemental.Transfer;
                        self.calcSum(
                          TransferArray,
                          "Unit",
                          partner,
                          "SupplementalTransfer"
                        );
                      }
                      if (partnerBusinessEventData.Supplemental.Forfeiture) {
                        let ForfeitureArray =
                          partnerBusinessEventData.Supplemental.Forfeiture;
                        self.calcSum(
                          ForfeitureArray,
                          "Unit",
                          partner,
                          "SupplementalForfeiture"
                        );
                      }
                      //partner.SupplementalTotal=partner.SupplementalIssuance + partner.SupplementalTransfer + partner.SupplementalForfeiture;
                    }
                    //Deal Calculation Added to Supplemental Sum
                    if (partnerBusinessEventData && partnerBusinessEventData.Deal) {
                      if (partnerBusinessEventData.Deal.Issuance) {
                        let IssuanceArray = partnerBusinessEventData.Deal.Issuance;
                        self.calcSum(
                          IssuanceArray,
                          "Unit",
                          partner,
                          "SupplementalIssuance"
                        );
                      }
                      if (partnerBusinessEventData.Deal.Transfer) {
                        let TransferArray = partnerBusinessEventData.Deal.Transfer;
                        self.calcSum(
                          TransferArray,
                          "Unit",
                          partner,
                          "SupplementalTransfer"
                        );
                      }
                      if (partnerBusinessEventData.Deal.Forfeiture) {
                        let ForfeitureArray =
                          partnerBusinessEventData.Deal.Forfeiture;
                        self.calcSum(
                          ForfeitureArray,
                          "Unit",
                          partner,
                          "SupplementalForfeiture"
                        );
                      }
                    }
                    partner.SupplementalTotal =
                      partner.SupplementalIssuance +
                      partner.SupplementalTransfer +
                      partner.SupplementalForfeiture;
      
                    partner.TotalUnits =
                      partner.StandardTotal + partner.SupplementalTotal;
      
                    //Get Partner Ownership using Class
                    partner.Ownership = self.getPartnerOwnership(partner.UnitClass);
                    //Adjusted Total Units
                    if(partner.Id == 1) {
                      //Bonus units deduction on the fly
                      //partner.TotalUnits -= self.bonusUnits;
                      partner.AdjustedTotalUnits =
                        partner.Ownership * partner.TotalUnits;
                    
                      //console.log("Bonus Units",self.bonusUnits);
                      } else {
                      partner.AdjustedTotalUnits =
                        partner.Ownership * partner.TotalUnits;
                      
                    }
      
                    if (partner.Id != 1) {
                      taxRunningTotal = taxRunningTotal + partner.AdjustedTotalUnits;
                      self.StoreRunningTotalByClass(
                        partner.UnitClass,
                        partner.TotalUnits
                      );
                    }
      
                    FMVRunningTotal = FMVRunningTotal + partner.AdjustedTotalUnits;
      
                    calculatedPartnerInfo.push(partner);
                  });
                });
              });
      
              //Populate Partner Specific Details
      
              //var partnerArrayfromDB= response.children.Partner;
              const partnerConfig = item => item.PartnerId;
              var groupedByPartner = deepGroupBy(tranData, partnerConfig);
      
              //Calculation for % Tax Ownership and Patner Specific details
              calculatedPartnerInfo.forEach(function(partner) {
                if (groupedByPartner[partner.Id] && groupedByPartner[partner.Id][0]) {
                  partner.PartnerTaxStatus =
                    groupedByPartner[partner.Id][0].PartnerTaxStatus;
                }
              });
      
              var isNonTaxPartner = false;
              let filteredPartnerInfo = _.filter(calculatedPartnerInfo, function(
                obj
              ) {
                return (
                  !isNullOrUndefined(obj.PartnerTaxStatus) &&
                  obj.PartnerTaxStatus === "Non-Tax"
                );
              });
      
              isNonTaxPartner = filteredPartnerInfo.length > 0;
      
              calculatedPartnerInfo = calculatedPartnerInfo.filter(
                partner => partner.Id == partnerId && partner.UnitClass == unitClass && partner.VestingType == vestingType
              );
      
              if (
                !isNullOrUndefined(calculatedPartnerInfo) &&
                calculatedPartnerInfo.length > 0
              ) {
                let classRunningTotal = self.FetchRunningTotalByClass(
                  calculatedPartnerInfo[0].UnitClass
                );

                //Bonus units deduction on the fly
                // var classBonusUnits = self.FetchRunningBonusUnitsByClass(calculatedPartnerInfo[0].UnitClass);
                // //console.log("classBonusUnits1",classBonusUnits);
                // classBonusUnits = classBonusUnits ? classBonusUnits : 0;

                calculatedPartnerInfo[0].TaxOwnership =
                 partnerId != 1 ? calculatedPartnerInfo[0].AdjustedTotalUnits /classRunningTotal : 0; 
                
                 // Remove NaN from excel export!
                 calculatedPartnerInfo[0].TaxOwnership = calculatedPartnerInfo[0].TaxOwnership ? calculatedPartnerInfo[0].TaxOwnership : 0;
                  
                if (!isNonTaxPartner) {

                  //Bonus units deduction on the fly
                  // calculatedPartnerInfo[0].FMVOwnership = calculatedPartnerInfo[0].AdjustedTotalUnits / (classRunningTotal - classBonusUnits);
                  calculatedPartnerInfo[0].FMVOwnership = calculatedPartnerInfo[0].AdjustedTotalUnits / classRunningTotal;
                  // Remove NaN from % 
                  calculatedPartnerInfo[0].FMVOwnership = calculatedPartnerInfo[0].FMVOwnership ? calculatedPartnerInfo[0].FMVOwnership : 0;
                }
                else{
                  calculatedPartnerInfo[0].FMVOwnership = calculatedPartnerInfo[0].AdjustedTotalUnits / FMVRunningTotal;
                  // Remove NaN from % 
                  calculatedPartnerInfo[0].FMVOwnership = calculatedPartnerInfo[0].FMVOwnership ? calculatedPartnerInfo[0].FMVOwnership : 0;                  
            }
           }
              console.log(calculatedPartnerInfo);
              return calculatedPartnerInfo;
            } else {
              return null;
            }
          },

          StoreRunningTotalByClass(unitClass, value) {
            if (this.classRunningTotalDict[unitClass]) {
              this.classRunningTotalDict[unitClass] += value;
            } else {
              this.classRunningTotalDict[unitClass] = value;
            }
          },

          FetchRunningTotalByClass(unitClass) {
            return this.classRunningTotalDict[unitClass];
          },
          
           calcSum(sourceArray, sourecField, target, targetField) {
            sourceArray.forEach(function(obj) {
              target[targetField] = target[targetField] + obj[sourecField];
            });
           },

            getPartnerOwnership(partnerUnitClass) {
            let UnitClassData = this.ProgramInfo.children.UnitClass;
            let UnitClass = _.find(UnitClassData, function(o) {
              return o.UnitClass == partnerUnitClass;
            });
            return UnitClass ? UnitClass.Ownership : 0;
          },
          calcBonusUnits(sourceArray) {
            let self = this;
            self.bonusUnits = 0;
            sourceArray.forEach(function(obj) {
              if(obj.UnitPool == "Treasury") {
                //console.log("Bonus Unit logs"+JSON.stringify(obj));
                //let Ownership = self.getPartnerOwnership(obj.UnitClass);
                var adjustedBonusUnits = obj.Unit;
                if(self.classRunningBonusUnits[obj.UnitClass]) {
                  self.classRunningBonusUnits[obj.UnitClass]+= adjustedBonusUnits;
                } else {
                  self.classRunningBonusUnits[obj.UnitClass] = adjustedBonusUnits;
                }
                self.bonusUnits += adjustedBonusUnits;
              }
            });
            return;
          },
          FetchRunningBonusUnitsByClass(unitClass){
            return this.classRunningBonusUnits[unitClass];
          }

    }
}